import React from 'react';
import css from './Table.module.scss';
import SortVertical01 from '../Icons/SortVertical01'
import PropTypes from 'prop-types';
import {useTableContext} from './TableContext';
import ColumnResizeHandle from './ColumnResizeHandle';

const TableSortableHeader = ({
  width,
  children,
  style,
  sortable,
  onSortColumn,
  index,
  align,
  className = '',
  rowSpan,
  colSpan,
  resizable = false,
  columnId,
}) => {
  const {cellAlign, columnWidths} = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';
  const isLeaf = !colSpan || Number(colSpan) <= 1;
  const isResizable = resizable && isLeaf && columnId !== undefined && columnId !== null;
  const storedWidth = columnId !== undefined && columnId !== null ? columnWidths[columnId] : undefined;
  const appliedWidth = storedWidth ?? width;

  const handleClick = () => {
    if (sortable) {
      onSortColumn(index);
    }
  };

  return (
    <th
      data-column-id={columnId ?? undefined}
      className={`${css.th} ${sortable ? css.thSortable : ''} ${isResizable ? css.thResizable : ''} ${className}`.trim()}
      style={{width: appliedWidth ?? undefined, cursor: sortable ? 'pointer' : 'default', textAlign: finalAlign, ...style}}
      onClick={sortable ? handleClick : undefined}
      rowSpan={rowSpan}
      colSpan={colSpan}
    >
      {children}
      {sortable && <SortVertical01 />}
      {isResizable &&
        <ColumnResizeHandle columnId={columnId} />
      }
    </th>
  );
};

TableSortableHeader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  rowSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sortable: PropTypes.bool,
  onSortColumn: PropTypes.func,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resizable: PropTypes.bool,
  columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableSortableHeader;
